import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';
import styles from './tier.module.scss';

export interface TierProps {
  tier?: string;
  className?: string;
}

const Tier: FC<TierProps> = ({tier, className}) => {
  const {t} = useTranslation();
  return (
    <div
      className={`rounded-[1.25rem] flex justify-center items-center ${
        styles[`tier-${tier}`]
      } ${className}`}>
      {t('agent.team-report.tier', {tier})}
    </div>
  );
};

export default Tier;
